import { type IconType } from '@lernit-org/lapzo-library';
import { type QuestionType } from './questions';

export interface Lesson {
  id?: string;
  course_id?: string;
  module_id?: string;
  author_id?: string;
  name: string;
  description?: string;
  index?: number;
  image_url?: string;
  type: LessonType;
  subtype?: LessonSubType;
  file?: any;
  fileUrl?: string;
  resource_type?: any;
  resource_content?: any;
  lessonResources?: LessonResource[];
  questions?: QuestionType[];
  tags?: string[];
  is_draft: boolean;
  is_active: boolean;
  is_private: boolean;
  random: boolean;
  access: LessonAccess;
  weighting?: any;
  attempts?: number;
  hours: number;
  minutes: number;
  restart_time: number;
  assign?: number;
  select?: boolean;
}

export interface LessonResource {
  type?: ResourceType;
  content: VimeoVideo | YoutubeVideo | ResourceFile;
}

export interface ResourceFile {
  name?: string;
  fullName?: string;
  filename?: string;
  url: string;
  size?: string;
}

export interface LessonItem {
  text: string;
  icon: IconType;
  action: () => void;
}

export enum LessonType {
  SCORM_HTML = 'SCORM_HTML',
  EVALUATION = 'EVALUATION',
  FORUM = 'FORUM',
  HTML5 = 'HTML5',
  LECTURE = 'LECTURE',
  SURVEY = 'SURVEY',
  TASK = 'TASK',
  VIDEO = 'VIDEO',
  PRESENTIAL = 'PRESENTIAL',
  UNKNOWN = 'UNKNOWN',
  ATTENDANCE = 'ATTENDANCE',
  ZOOM = 'ZOOM',
}

export enum LessonSubType {
  HTML = 'HTML',
  PDF = 'PDF',
}

export enum LessonAccess {
  FREE = 'FREE',
  PAID = 'PAID',
}

export enum ResourceType {
  HTML = 'html',
  LECTURE = 'lecture',
  VIDEO = 'video',
  EMBED = 'embed',
  VIDEOALTER = 'videoalter',
  IMAGE = 'image',
  RESOURCES = 'resources',
}

export enum VideoType {
  YOUTUBE = 'youtube',
  VIMEO = 'vimeo',
  UPLOAD = 'upload',
}

export enum ValuesRestartTime {
  next24hours = '24',
  next36hours = '36',
  next48hours = '48',
  reboot = '0',
}
export enum LessonGrades {
  MANUAL = '1',
  AUTO = '0',
}

export interface VimeoVideo {
  code: string;
  type: VideoType.VIMEO;
  title: string;
  author: string;
  account: string;
  channel: string;
  duration?: number;
  subtitles?: SubtitleVideo[];
  thumbnail: string;
}

export interface YoutubeVideo {
  code: string;
  type: VideoType.YOUTUBE;
  title: string;
  author: string;
  channel: string;
  duration?: number;
  channelId: string;
  thumbnail: string;
}

export enum videoLangs {
  ES = 'es',
  EN = 'en',
  PT = 'pt',
}

export interface SubtitleVideo {
  url: string;
  lang: string;
  name: string;
  size: string;
  filename: string;
  fullname: string;
}
